import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=407cc79e"
import script from "./PasswordReset.ts?vue&type=script&lang=js&external"
export * from "./PasswordReset.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports